var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"portal-context"}},[_c('context-picker',{attrs:{"id":"main-context-picker","title":"Group Selected","transitionName":"slide-fade","closeOnOutsideClick":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }